import { AnalyticsAccountTypes } from '../store/paymentsReducer';

const paymentTypeMap: Record<string, string> = {
  VISA: 'Visa',
  AMEX: 'American Express',
  SVG: 'Savings',
  CHKG: 'Checking',
  Savings: 'Savings',
  Checking: 'Checking',
  DISC: 'Discover',
  MASTR: 'Mastercard',
};

export default paymentTypeMap;

export const getPaymentCommonName = (type: string): AnalyticsAccountTypes => {
  const cardArray = ['VISA', 'AMEX', 'DISC', 'MASTR'];
  const checkingArray = ['CHKG', 'Checking'];
  if (cardArray.includes(type)) return 'Debit/Credit Card';
  else if (checkingArray.includes(type)) return 'Checking Account';
  else return 'Savings Account';
};
